import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

const axios = require('axios');

export default class InstantChat {
	constructor(chatAmount) {
		this._chatAmount = chatAmount;
		this.iteration = 0;
		this.currentHost = 0;
		this.signupExists = false;

		helper.addEventListener(window, Events.CREATE_SIGNUP, () => {
			this.signupExists = true;
		});

		helper.addEventListener(window, 'paytourClose', () => {
			this.signupExists = false;
		});
	}

	random() {
		if (!this.signupExists) {
			if (this.iteration >= this._chatAmount) {
				helper.triggerEvent(window, Events.VIDEO_LIMIT_REACHED);
				helper.triggerEvent(window, Events.CREATE_SIGNUP);
			} else {
				axios.get('/rest/vx/instachat/random?current=' + this.currentHost)
					.then((result) => {
						this.currentHost = result.data.data.uid;
						helper.triggerEvent(window, Events.VIDEO_CHANGED, result.data.data);
						this.iteration++;
					})
					.catch(() => {});
			}
		}
	}
}
